module.exports = __webpack_public_path__ + "img/einfach_weniger_stress.42fca48b.png";